import React from 'react';
import DataProviderContext from './DataProviderContext';

export const useDataProvider = () => {
  return React.useContext(DataProviderContext);
};
